import React, { useEffect, useState, createElement, Component } from 'react';
import { Shield, Check, AlertTriangle, MessageCircle, Lock, Phone, XCircle, CheckCircle2, ChevronRight, Clock, FileText, X } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
// Initialize Meta Pixel
const initMetaPixel = () => {
  if (typeof window !== 'undefined' && !window.fbq) {
    const f = window as any;
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize with your Pixel ID
    window.fbq('init', '1221158382812131');
  }
};
// Track PageView
const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};
// Track AddToCart
const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Anti-Estafas WhatsApp para Jubiladas',
      content_type: 'product',
      value: 9300,
      currency: 'ARS'
    });
  }
};
// Color Palette Definition
// Navy: #1e3a5f (Primary text, headings, hero bg)
// Cream: #fdfbf7 (Main background)
// Teal: #2a9d8f (Accents, secondary buttons)
// WhatsApp: #25D366 (Specific accents, trust markers)
// Warning: #e76f51 (Alerts)
const Hero = () => <section className="bg-[#1e3a5f] text-white py-12 px-6 md:py-20" data-id="element-1">
    <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-2">
      <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full mb-6 backdrop-blur-sm border border-white/20" data-id="element-3">
        <Shield className="w-5 h-5 text-[#25D366]" data-id="element-4" />
        <span className="text-sm md:text-base font-medium tracking-wide" data-id="element-5">
          Seguridad Digital Simplificada
        </span>
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 tracking-tight" data-id="element-6">
        Si te apuran por WhatsApp,{' '}
        <span className="text-[#25D366]" data-id="element-7">no es tu problema.</span>
      </h1>

      <p className="text-xl md:text-2xl text-gray-200 mb-10 leading-relaxed max-w-2xl" data-id="element-8">
        La guía súper visual de 7 días para configurar tu WhatsApp, detectar
        trampas y cortar conversaciones raras sin vergüenza.
      </p>

      <div className="w-full max-w-md mb-10 shadow-2xl rounded-xl overflow-hidden border-4 border-white/10" data-id="element-9">
        <img src="https://cdn.magicpatterns.com/uploads/u9uoncQmBUHXg4CQadZkL6/heylloyd-image-1770023546819.png" alt="Guía Anti-Estafas WhatsApp en una tablet" className="w-full h-auto object-cover" data-id="element-10" />
      </div>

      <a href="#precio" className="bg-[#25D366] hover:bg-[#20bd5a] text-[#1e3a5f] text-xl md:text-2xl font-bold py-4 px-8 rounded-full shadow-lg transform transition-transform active:scale-95 w-full md:w-auto flex items-center justify-center gap-3" data-id="element-11">
        Quiero mi protocolo
        <ChevronRight className="w-6 h-6" data-id="element-12" />
      </a>

      <p className="mt-4 text-sm text-gray-300 flex items-center gap-2" data-id="element-13">
        <Lock className="w-4 h-4" data-id="element-14" /> Compra segura y descarga inmediata
      </p>
    </div>
  </section>;
const OpeningLead = () => <section className="bg-[#fdfbf7] py-16 px-6" data-id="element-15">
    <div className="max-w-2xl mx-auto" data-id="element-16">
      <p className="text-xl md:text-2xl text-[#1e3a5f] leading-relaxed mb-8 font-medium" data-id="element-17">
        Te pasa así: estás tranquila, haciendo lo tuyo… y entra un mensaje.
      </p>

      <div className="space-y-6 mb-10" data-id="element-18">
        <div className="bg-white p-5 rounded-tr-2xl rounded-bl-2xl rounded-br-2xl shadow-sm border-l-4 border-[#25D366] max-w-lg" data-id="element-19">
          <p className="text-lg text-gray-800" data-id="element-20">
            "No soy yo, mamá. Me robaron el celular."
          </p>
        </div>
        <div className="bg-white p-5 rounded-tr-2xl rounded-bl-2xl rounded-br-2xl shadow-sm border-l-4 border-[#25D366] max-w-lg" data-id="element-21">
          <p className="text-lg text-gray-800" data-id="element-22">
            "Ojo, detectamos actividad inusual. Confirmá tus datos."
          </p>
        </div>
        <div className="bg-white p-5 rounded-tr-2xl rounded-bl-2xl rounded-br-2xl shadow-sm border-l-4 border-[#25D366] max-w-lg" data-id="element-23">
          <p className="text-lg text-gray-800" data-id="element-24">
            "Te llegó un código, pasámelo así lo arreglo."
          </p>
        </div>
      </div>

      <div className="bg-[#1e3a5f]/5 p-8 rounded-2xl border border-[#1e3a5f]/10" data-id="element-25">
        <p className="text-xl md:text-2xl text-[#1e3a5f] leading-relaxed mb-6" data-id="element-26">
          Y en ese segundo te agarra la peor combinación:{' '}
          <strong className="text-[#e76f51]" data-id="element-27">apuro + miedo + vergüenza</strong>.
        </p>
        <ul className="space-y-4 text-lg text-[#1e3a5f]/80" data-id="element-28">
          <li className="flex items-start gap-3" data-id="element-29">
            <Clock className="w-6 h-6 text-[#e76f51] shrink-0 mt-1" data-id="element-30" />
            <span data-id="element-31">Apuro porque "capaz pasa algo si no contesto ya".</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-32">
            <AlertTriangle className="w-6 h-6 text-[#e76f51] shrink-0 mt-1" data-id="element-33" />
            <span data-id="element-34">Miedo porque no querés caer.</span>
          </li>
          <li className="flex items-start gap-3" data-id="element-35">
            <XCircle className="w-6 h-6 text-[#e76f51] shrink-0 mt-1" data-id="element-36" />
            <span data-id="element-37">
              Vergüenza porque sentís que "a esta altura tendría que entender".
            </span>
          </li>
        </ul>
      </div>

      <p className="text-xl md:text-2xl text-[#1e3a5f] leading-relaxed mt-10 font-bold text-center" data-id="element-38">
        Esto no se arregla con "tené cuidado".
        <br data-id="element-39" />
        Se arregla con un protocolo simple.
      </p>
    </div>
  </section>;
const ProblemSection = () => <section className="bg-white py-16 px-6 border-t border-gray-100" data-id="element-40">
    <div className="max-w-3xl mx-auto" data-id="element-41">
      <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-8 text-center" data-id="element-42">
        Las estafas no ganan porque vos "no sabés"
      </h2>

      <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8" data-id="element-43">
        Ganan porque te agarran en un momento humano: distraída, apurada, con
        miedo de equivocarte. Y encima te empujan una emoción que paraliza:{' '}
        <strong data-id="element-44">la vergüenza</strong>.
      </p>

      <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-12" data-id="element-45">
        Esa cosa silenciosa que te hace pensar: "Mejor contesto rápido y listo",
        "Mejor no pregunto", "Mejor no molesto". Ahí te ganan.
      </p>

      <h3 className="text-2xl font-bold text-[#1e3a5f] mb-6" data-id="element-46">
        Por qué lo que probaste no alcanza:
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-47">
        {['“No hagas clic” no sirve cuando te ponen urgencia.', 'Ver videos no ayuda si en el momento no recordás qué hacer.', 'Depender de alguien falla porque la estafa no espera.', 'Nadie te dio el guion exacto para cortar.'].map((item, i) => <div key={i} className="flex items-start gap-4 p-4 bg-red-50 rounded-xl border border-red-100" data-id="element-48">
            <XCircle className="w-6 h-6 text-[#e76f51] shrink-0" data-id="element-49" />
            <p className="text-lg text-[#1e3a5f]" data-id="element-50">{item}</p>
          </div>)}
      </div>
    </div>
  </section>;
const SolutionReveal = () => <section className="bg-[#1e3a5f] text-white py-20 px-6" data-id="element-51">
    <div className="max-w-4xl mx-auto" data-id="element-52">
      <div className="text-center mb-16" data-id="element-53">
        <span className="text-[#25D366] font-bold tracking-wider uppercase text-sm md:text-base mb-2 block" data-id="element-54">
          El Método
        </span>
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-55">
          La solución: PAUSA – VERIFICÁ – BLOQUEÁ
        </h2>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-56">
          Este producto no te pide que seas experta. Te da un sistema repetible.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-57">
        {/* Step 1 */}
        <div className="bg-white text-[#1e3a5f] p-8 rounded-2xl shadow-xl relative overflow-hidden group" data-id="element-58">
          <div className="absolute top-0 right-0 bg-blue-100 text-[#1e3a5f] font-bold px-4 py-2 rounded-bl-xl text-xl" data-id="element-59">
            1
          </div>
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 text-[#1e3a5f]" data-id="element-60">
            <span className="text-3xl" data-id="element-61">✋</span>
          </div>
          <h3 className="text-2xl font-bold mb-3" data-id="element-62">PAUSA</h3>
          <p className="text-lg text-gray-600" data-id="element-63">
            Cortás el impulso inmediato. Te damos la técnica de los 10 segundos.
          </p>
        </div>

        {/* Step 2 */}
        <div className="bg-white text-[#1e3a5f] p-8 rounded-2xl shadow-xl relative overflow-hidden group" data-id="element-64">
          <div className="absolute top-0 right-0 bg-teal-100 text-teal-800 font-bold px-4 py-2 rounded-bl-xl text-xl" data-id="element-65">
            2
          </div>
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 text-teal-800" data-id="element-66">
            <span className="text-3xl" data-id="element-67">🔍</span>
          </div>
          <h3 className="text-2xl font-bold mb-3" data-id="element-68">VERIFICÁ</h3>
          <p className="text-lg text-gray-600" data-id="element-69">
            Checklist visual rápido (30–90 segundos) para confirmar si es real.
          </p>
        </div>

        {/* Step 3 */}
        <div className="bg-white text-[#1e3a5f] p-8 rounded-2xl shadow-xl relative overflow-hidden group" data-id="element-70">
          <div className="absolute top-0 right-0 bg-red-100 text-red-800 font-bold px-4 py-2 rounded-bl-xl text-xl" data-id="element-71">
            3
          </div>
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6 text-red-800" data-id="element-72">
            <span className="text-3xl" data-id="element-73">🔒</span>
          </div>
          <h3 className="text-2xl font-bold mb-3" data-id="element-74">BLOQUEÁ</h3>
          <p className="text-lg text-gray-600" data-id="element-75">
            Pasos claros para cerrar la puerta y que no vuelvan por ahí.
          </p>
        </div>
      </div>

      <div className="bg-[#25D366]/10 border border-[#25D366]/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-76">
        <h3 className="text-2xl font-bold text-[#25D366] mb-4 flex items-center justify-center gap-3" data-id="element-77">
          <MessageCircle className="w-8 h-8" data-id="element-78" />
          Incluye: Frases-Cortaestafa
        </h3>
        <p className="text-lg md:text-xl text-white" data-id="element-79">
          Listas para copiar y pegar. Porque en la vida real, lo que te frena no
          es el botón… es qué decir sin quedar pegada.
        </p>
      </div>
    </div>
  </section>;
const WhatsIncluded = () => <section className="bg-[#fdfbf7] py-16 px-6" data-id="element-80">
    <div className="max-w-4xl mx-auto" data-id="element-81">
      <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-12 text-center" data-id="element-82">
        Qué incluye la guía
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-83">
        {['Ebook súper visual (paso a paso)', 'Checklist de configuración de WhatsApp', 'Señales rojas (las que se repiten)', 'Protocolos para: código / soporte falso / familiar en apuros', 'Plan 7 días (micro-práctica)', "Sección '¿y si ya respondí?' (primeros pasos)"].map((item, i) => <div key={i} className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-sm border border-gray-100" data-id="element-84">
            <div className="bg-[#25D366]/20 p-2 rounded-full shrink-0" data-id="element-85">
              <Check className="w-6 h-6 text-[#1e3a5f]" data-id="element-86" />
            </div>
            <span className="text-lg md:text-xl text-[#1e3a5f] font-medium" data-id="element-87">
              {item}
            </span>
          </div>)}
      </div>
    </div>
  </section>;
const AudienceSection = () => <section className="bg-white py-16 px-6" data-id="element-88">
    <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-89">
      {/* For Whom */}
      <div data-id="element-90">
        <h3 className="text-2xl font-bold text-[#1e3a5f] mb-6 flex items-center gap-3" data-id="element-91">
          <CheckCircle2 className="w-8 h-8 text-[#25D366]" data-id="element-92" />
          Para quién es
        </h3>
        <ul className="space-y-4" data-id="element-93">
          {['Mujeres +60 que usan WhatsApp todos los días', 'Personas que quieren tranquilidad sin depender de otros', 'Quien quiere un método simple, no teoría técnica'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-gray-700" data-id="element-94">
              <span className="w-2 h-2 bg-[#25D366] rounded-full mt-2.5 shrink-0" data-id="element-95"></span>
              {item}
            </li>)}
        </ul>
      </div>

      {/* Not For Whom */}
      <div data-id="element-96">
        <h3 className="text-2xl font-bold text-[#1e3a5f] mb-6 flex items-center gap-3" data-id="element-97">
          <XCircle className="w-8 h-8 text-[#e76f51]" data-id="element-98" />
          Para quién NO es
        </h3>
        <ul className="space-y-4" data-id="element-99">
          {['Quien busca promesas mágicas', "Quien quiere 'recuperar plata' con garantías", 'Quien no está dispuesta a aplicar 3 pasos simples'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-gray-700" data-id="element-100">
              <span className="w-2 h-2 bg-[#e76f51] rounded-full mt-2.5 shrink-0" data-id="element-101"></span>
              {item}
            </li>)}
        </ul>
      </div>
    </div>
  </section>;
const PricingSection = () => {
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = 'https://argrutinas.com/cart/42959095660753:1';
  };
  return <section id="precio" className="bg-[#fdfbf7] py-20 px-6 border-t border-gray-200" data-id="element-102">
      <div className="max-w-3xl mx-auto text-center" data-id="element-103">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100 relative overflow-hidden" data-id="element-104">
          <div className="absolute top-4 right-4 bg-[#e76f51] text-white font-bold px-4 py-2 rounded-full text-sm md:text-base" data-id="element-105">
            50% OFF
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4" data-id="element-106">
            Recuperá tu tranquilidad hoy
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-107">
            Acceso inmediato a la guía digital completa
          </p>

          <div className="flex flex-col items-center justify-center gap-2 mb-10" data-id="element-108">
            <span className="text-gray-400 text-2xl line-through decoration-red-400 decoration-2" data-id="element-109">
              $18.600 ARS
            </span>
            <span className="text-5xl md:text-6xl font-bold text-[#1e3a5f]" data-id="element-110">
              $9.300 ARS
            </span>
            <span className="text-[#25D366] font-semibold text-lg" data-id="element-111">
              ¡Ahorrás $9.300!
            </span>
          </div>

          <button onClick={handleBuyClick} className="w-full bg-[#1e3a5f] hover:bg-[#162c47] text-white text-xl md:text-2xl font-bold py-5 px-8 rounded-full shadow-lg transform transition-transform active:scale-95 mb-6 flex items-center justify-center gap-3 cursor-pointer" data-id="element-112">
            Quiero recuperar mi tranquilidad
            <ChevronRight className="w-6 h-6" data-id="element-113" />
          </button>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-500" data-id="element-114">
            <span className="flex items-center gap-2" data-id="element-115">
              <Lock className="w-4 h-4" data-id="element-116" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-117">
              <Check className="w-4 h-4" data-id="element-118" /> Acceso de por vida
            </span>
            <span className="flex items-center gap-2" data-id="element-119">
              <Phone className="w-4 h-4" data-id="element-120" /> Compatible con todo celular
            </span>
          </div>
        </div>

        <div className="mt-16 max-w-2xl mx-auto" data-id="element-121">
          <h3 className="text-2xl md:text-3xl font-bold text-[#1e3a5f] mb-6" data-id="element-122">
            No necesitás aprender tecnología.
            <br data-id="element-123" />
            Necesitás recuperar algo más importante:{' '}
            <span className="text-[#2a9d8f]" data-id="element-124">control</span>.
          </h3>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-125">
            Si hoy te gana el apuro, mañana te puede costar caro. Este es tu
            protocolo simple para que cuando aparezca el mensaje raro… no te
            encuentre sola, ni apurada, ni dudando.
          </p>
        </div>
      </div>
    </section>;
};
// Modal Component
const Modal = ({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-126">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-127" />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-128">
        <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-129">
          <h2 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-130">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-131">
            <X className="w-6 h-6 text-gray-500" data-id="element-132" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[60vh]" data-id="element-133">{children}</div>
      </div>
    </div>;
};
const PrivacyContent = () => <div className="prose prose-lg text-gray-700 space-y-4" data-id="element-134">
    <p className="text-lg leading-relaxed" data-id="element-135">
      <strong data-id="element-136">Última actualización:</strong> Enero 2025
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-137">
      1. Información que Recopilamos
    </h3>
    <p data-id="element-138">
      Recopilamos información personal que nos proporcionás voluntariamente al
      realizar una compra, como tu nombre y dirección de correo electrónico.
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-139">
      2. Uso de la Información
    </h3>
    <p data-id="element-140">Utilizamos tu información únicamente para:</p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-141">
      <li data-id="element-142">Procesar tu compra y entregarte el producto digital</li>
      <li data-id="element-143">Enviarte actualizaciones importantes sobre tu compra</li>
      <li data-id="element-144">Responder a tus consultas o solicitudes de soporte</li>
    </ul>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-145">
      3. Protección de Datos
    </h3>
    <p data-id="element-146">
      Implementamos medidas de seguridad para proteger tu información personal.
      No vendemos, intercambiamos ni transferimos tu información a terceros sin
      tu consentimiento.
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-147">4. Cookies</h3>
    <p data-id="element-148">
      Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
      navegación. Podés configurar tu navegador para rechazar cookies si lo
      preferís.
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-149">5. Tus Derechos</h3>
    <p data-id="element-150">
      Tenés derecho a acceder, rectificar o eliminar tus datos personales en
      cualquier momento.
    </p>
  </div>;
const TermsContent = () => <div className="prose prose-lg text-gray-700 space-y-4" data-id="element-151">
    <p className="text-lg leading-relaxed" data-id="element-152">
      <strong data-id="element-153">Última actualización:</strong> Enero 2025
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-154">
      1. Aceptación de los Términos
    </h3>
    <p data-id="element-155">
      Al comprar y acceder a "Anti-Estafas WhatsApp para Jubiladas", aceptás
      estos términos y condiciones en su totalidad.
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-156">
      2. Descripción del Producto
    </h3>
    <p data-id="element-157">
      Este es un producto digital educativo que incluye una guía en formato PDF
      con información sobre prevención de estafas por WhatsApp. El producto se
      entrega de forma inmediata tras la compra.
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-158">
      3. Uso del Producto
    </h3>
    <p data-id="element-159">El producto es para uso personal únicamente. No está permitido:</p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-160">
      <li data-id="element-161">Redistribuir, vender o compartir el contenido</li>
      <li data-id="element-162">Modificar o crear obras derivadas</li>
      <li data-id="element-163">Utilizar el contenido con fines comerciales sin autorización</li>
    </ul>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-164">
      4. Limitación de Responsabilidad
    </h3>
    <p data-id="element-165">
      Este producto es una herramienta educativa de prevención. No garantizamos
      la recuperación de dinero perdido en estafas anteriores ni la prevención
      absoluta de futuras estafas. La efectividad depende de la aplicación
      correcta de las recomendaciones.
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-166">
      5. Política de Reembolso
    </h3>
    <p data-id="element-167">
      Debido a la naturaleza digital del producto y su entrega inmediata, no se
      aceptan devoluciones una vez realizada la descarga. Si tenés problemas
      técnicos para acceder al producto, te ayudaremos a resolverlos.
    </p>

    <h3 className="text-xl font-bold text-[#1e3a5f] mt-6" data-id="element-168">6. Modificaciones</h3>
    <p data-id="element-169">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Los cambios serán efectivos inmediatamente después de su
      publicación.
    </p>
  </div>;
const Footer = () => {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-[#1e3a5f] text-white py-12 px-6 text-center" data-id="element-170">
        <div className="max-w-4xl mx-auto" data-id="element-171">
          <div className="flex items-center justify-center gap-2 mb-8 opacity-80" data-id="element-172">
            <Shield className="w-6 h-6" data-id="element-173" />
            <span className="text-lg font-medium" data-id="element-174">Anti-Estafas WhatsApp</span>
          </div>
          <p className="text-gray-400 text-sm mb-6" data-id="element-175">
            Este producto no garantiza la recuperación de dinero perdido en
            estafas anteriores. Es una herramienta educativa de prevención.
          </p>

          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-176">
            <button onClick={() => setPrivacyOpen(true)} className="text-gray-300 hover:text-white text-sm underline underline-offset-4 transition-colors" data-id="element-177">
              Política de Privacidad
            </button>
            <span className="text-gray-500" data-id="element-178">|</span>
            <button onClick={() => setTermsOpen(true)} className="text-gray-300 hover:text-white text-sm underline underline-offset-4 transition-colors" data-id="element-179">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-gray-500 text-sm" data-id="element-180">
            © {new Date().getFullYear()} Todos los derechos reservados. Hecho
            con cuidado en Argentina.
          </p>
        </div>
      </footer>

      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-181">
        <PrivacyContent data-id="element-182" />
      </Modal>

      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-183">
        <TermsContent data-id="element-184" />
      </Modal>
    </>;
};
export function SalesPage() {
  useEffect(() => {
    // Initialize Meta Pixel and track PageView on mount
    initMetaPixel();
    // Small delay to ensure pixel is loaded
    const timer = setTimeout(() => {
      trackPageView();
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-[#fdfbf7] font-sans" data-id="element-185">
      {/* Noscript fallback for Meta Pixel */}
      <noscript data-id="element-186">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1221158382812131&ev=PageView&noscript=1" alt="" data-id="element-187" />
      </noscript>
      <Hero data-id="element-188" />
      <OpeningLead data-id="element-189" />
      <ProblemSection data-id="element-190" />
      <SolutionReveal data-id="element-191" />
      <WhatsIncluded data-id="element-192" />
      <AudienceSection data-id="element-193" />
      <PricingSection data-id="element-194" />
      <Footer data-id="element-195" />
    </div>;
}